import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import type {
  PostcodeSuggestion,
  ShippingQuoteRequest,
  ShippingQuoteResult,
} from '../models/shipping-calculator.model';

@Injectable({ providedIn: 'root' })
export class ShippingCalculatorService {
  constructor(private readonly http: HttpClient) {}

  searchPostcodes(query: string): Observable<PostcodeSuggestion[]> {
    return this.http.get<PostcodeSuggestion[]>(`${API_BASE_URL}/shipping/postcodes`, {
      params: { q: query },
    });
  }

  getQuote(payload: ShippingQuoteRequest): Observable<ShippingQuoteResult> {
    return this.http.post<ShippingQuoteResult>(`${API_BASE_URL}/shipping/quote`, payload);
  }
}
